export default __webpack_public_path__ + "static/media/news1.38f81141.jpg";